<template>
	<div style="padding: 12px; background: #FFFFFF;">
		<div class="title">
			{{Article.title|decode}}
		</div>
		<div class="date">
			{{Article.cdate|gdate}}
			<span class="author">
				{{Article.subtype==1?'肠胃调理':''}}
				{{Article.subtype==2?'婴童皮肤护理':''}}
				{{Article.subtype==3?'特殊配方':''}}
				{{Article.subtype==4?'基础护理':''}}
				{{Article.subtype==5?'生物抗菌':''}}
			</span>
		</div>
		<div class="content" v-html="Article.contentinfo">

		</div>
		<div id="qrcode" v-show="qrcodeurl" style="width: 42%; margin: 0 auto; padding: 20px; background: #fff; border-radius: 8px;"></div>
		<div class="artinfo">
			<!--<span class="author" style="padding-left: 0; margin-right: 10px;" @click="GoLink" v-if="Article.link!=''">阅读原文</span>-->
			<span style="margin-right: 10px;">阅读 {{Article.viewcount}}</span>
			<span>
				
				
				<svg class="icon" v-if="!zaned" @click="ZanArt" style="width: 16px; height: 16px;vertical-align: top;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2409"><path d="M227.429291 458.263122l0 439.897845L100.978321 898.160967 100.978321 458.263122 227.429291 458.263122M264.268314 421.424098 64.139298 421.424098l0 513.575892 200.129017 0L264.268314 421.424098 264.268314 421.424098zM529.370111 125.839033c9.071609 0 36.418444 5.799076 53.788044 32.281217 11.538801 17.59268 16.916275 41.307801 15.985066 70.487378-1.27504 39.889499-14.288424 88.585571-38.679951 144.737452l-0.01535 0.034792c-0.200568 0.390903-0.594541 1.11745-0.893346 1.666966-1.480724 2.731204-3.50994 6.471388-5.092995 10.819416-5.430686 14.915711-2.7486 30.318516 7.161097 41.343617 7.773034 8.704243 18.503423 13.491269 30.270421 13.491269 5.729491 0 10.242272-1.124614 13.537318-1.946328 2.033309-0.50756 3.384074-0.844228 5.314029-0.997724 21.658276-1.645476 60.027142-3.402493 102.775758-3.402493 52.774971 0 99.724259 2.650363 135.774313 7.66661 51.42216 7.154957 67.296709 17.21508 70.834278 20.001543 1.659803 6.203282 4.489244 22.589484 1.759063 56.865125-2.424212 30.42801-8.53949 66.109674-17.682731 103.189174-20.832468 84.47188-53.527101 162.04463-89.697905 212.8262-20.555152 28.857235-52.438303 63.256696-87.598081 63.256696L315.765175 898.159944l-5.432733-455.685413c16.372899-9.969049 41.007973-26.01142 66.424852-46.39261 62.029752-49.737798 97.397261-99.81124 105.119129-148.821467 7.30436-46.298466 15.922644-78.997192 26.348088-99.966783 5.215792-10.490935 9.770528-15.639189 12.672624-18.10945 3.053546-2.600221 5.282307-3.123131 7.28594-3.305279 0.137123-0.013303 0.528026-0.041956 1.182942-0.041956l0.00307 0L529.370111 125.836987M529.366018 88.998987c-1.630127 0-3.160993 0.068562-4.569062 0.198521-41.508369 3.773953-64.215534 56.646138-79.3093 152.323221-15.072277 95.655594-172.248016 179.902346-172.248016 179.902346l6.123464 513.575892L726.90914 934.998967c157.068292 0 258.286578-397.802098 227.408313-487.095797-14.193257-41.020252-140.319839-50.387597-240.796228-50.387597-43.927465 0-82.95227 1.790786-105.576547 3.508917-8.566096 0.665149-13.129019 2.836605-16.051581 2.836605-1.153266 0-2.051729-0.338714-2.838651-1.24127-2.264577-2.436492 3.258207-9.918907 5.197372-14.598486C701.12694 141.983735 574.845839 88.995917 529.366018 88.998987L529.366018 88.998987z" p-id="2410"></path></svg>
			
				<svg class="icon" v-else style="width: 16px; height: 16px;vertical-align: top;fill: #5c91e2;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1819"><path d="M896.8 550.4c20.8-32 28-62.4 21.6-89.6-7.2-28-28-48.8-44-58.4-13.6-8-29.6-12-45.6-12L703.2 390.4c-19.2 0-36.8-9.6-47.2-24.8-10.4-16-12.8-35.2-4.8-52.8 15.2-34.4 21.6-85.6 22.4-104 0-59.2-14.4-100.8-41.6-120-29.6-21.6-67.2-12-78.4-8-26.4 8-32.8 32.8-40.8 82.4-1.6 11.2-4 22.4-6.4 33.6C491.2 268.8 456 336 405.6 388.8c-27.2 28-56 52-86.4 69.6-10.4 5.6-20.8 11.2-32 15.2l0 411.2c40 1.6 72.8 12 109.6 24 56.8 18.4 127.2 40.8 259.2 40.8l1.6 0c66.4 0 115.2-15.2 141.6-43.2 24.8-26.4 24-56.8 24-59.2-1.6-12 4.8-23.2 15.2-29.6 20.8-12 32.8-27.2 36.8-43.2 6.4-25.6-8.8-51.2-9.6-52.8-9.6-14.4-5.6-32.8 8.8-43.2 21.6-14.4 33.6-29.6 36-46.4 4-22.4-11.2-42.4-12-44C889.6 576 889.6 561.6 896.8 550.4zM97.6 492l0 384c0 4.8-4.8 21.6 0 21.6L200 897.6 200 486.4l-94.4-2.4C100.8 484 97.6 487.2 97.6 492z" p-id="1820"></path></svg>
				 {{Article.zan>0?Article.zan:''}}
			
			</span>

			<span class="author" style="float: right;" @click="ShowPLBar">写评论</span>
		</div>
		<div style="height: 50px;"></div>
		<div class="reply-box" id="reply-box" style="bottom: 0; display: none;">
			<input type="text" id="dmtxt" placeholder="说点什么..." v-model="mywords" @focus="MoveTxtUp" @blur="MoveTxtDown" />
			<div class="btn-replay" @click="SaveComment">发送</div>
		</div>
		<div>
			<div class="commentitem" v-for="item of CommentsList">
				<div class="headimg">
					<img :src="item.headimgurl" />
				</div>
				<div class="userinfo">
					<div>{{item.nickname}}</div>
					<div>{{item.time}}</div>
				</div>
				<div class="summary">
					{{item.summary}}
				</div>
				<div class="commentzan">
					<span>
						<svg class="icon" v-if="!item.zaned" @click="ZanComment(item.commentid)" style="width: 16px; height: 16px;vertical-align: top;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2409"><path d="M227.429291 458.263122l0 439.897845L100.978321 898.160967 100.978321 458.263122 227.429291 458.263122M264.268314 421.424098 64.139298 421.424098l0 513.575892 200.129017 0L264.268314 421.424098 264.268314 421.424098zM529.370111 125.839033c9.071609 0 36.418444 5.799076 53.788044 32.281217 11.538801 17.59268 16.916275 41.307801 15.985066 70.487378-1.27504 39.889499-14.288424 88.585571-38.679951 144.737452l-0.01535 0.034792c-0.200568 0.390903-0.594541 1.11745-0.893346 1.666966-1.480724 2.731204-3.50994 6.471388-5.092995 10.819416-5.430686 14.915711-2.7486 30.318516 7.161097 41.343617 7.773034 8.704243 18.503423 13.491269 30.270421 13.491269 5.729491 0 10.242272-1.124614 13.537318-1.946328 2.033309-0.50756 3.384074-0.844228 5.314029-0.997724 21.658276-1.645476 60.027142-3.402493 102.775758-3.402493 52.774971 0 99.724259 2.650363 135.774313 7.66661 51.42216 7.154957 67.296709 17.21508 70.834278 20.001543 1.659803 6.203282 4.489244 22.589484 1.759063 56.865125-2.424212 30.42801-8.53949 66.109674-17.682731 103.189174-20.832468 84.47188-53.527101 162.04463-89.697905 212.8262-20.555152 28.857235-52.438303 63.256696-87.598081 63.256696L315.765175 898.159944l-5.432733-455.685413c16.372899-9.969049 41.007973-26.01142 66.424852-46.39261 62.029752-49.737798 97.397261-99.81124 105.119129-148.821467 7.30436-46.298466 15.922644-78.997192 26.348088-99.966783 5.215792-10.490935 9.770528-15.639189 12.672624-18.10945 3.053546-2.600221 5.282307-3.123131 7.28594-3.305279 0.137123-0.013303 0.528026-0.041956 1.182942-0.041956l0.00307 0L529.370111 125.836987M529.366018 88.998987c-1.630127 0-3.160993 0.068562-4.569062 0.198521-41.508369 3.773953-64.215534 56.646138-79.3093 152.323221-15.072277 95.655594-172.248016 179.902346-172.248016 179.902346l6.123464 513.575892L726.90914 934.998967c157.068292 0 258.286578-397.802098 227.408313-487.095797-14.193257-41.020252-140.319839-50.387597-240.796228-50.387597-43.927465 0-82.95227 1.790786-105.576547 3.508917-8.566096 0.665149-13.129019 2.836605-16.051581 2.836605-1.153266 0-2.051729-0.338714-2.838651-1.24127-2.264577-2.436492 3.258207-9.918907 5.197372-14.598486C701.12694 141.983735 574.845839 88.995917 529.366018 88.998987L529.366018 88.998987z" p-id="2410"></path></svg>
					
						<svg class="icon" v-else style="width: 16px; height: 16px;vertical-align: top;fill: #5c91e2;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1819"><path d="M896.8 550.4c20.8-32 28-62.4 21.6-89.6-7.2-28-28-48.8-44-58.4-13.6-8-29.6-12-45.6-12L703.2 390.4c-19.2 0-36.8-9.6-47.2-24.8-10.4-16-12.8-35.2-4.8-52.8 15.2-34.4 21.6-85.6 22.4-104 0-59.2-14.4-100.8-41.6-120-29.6-21.6-67.2-12-78.4-8-26.4 8-32.8 32.8-40.8 82.4-1.6 11.2-4 22.4-6.4 33.6C491.2 268.8 456 336 405.6 388.8c-27.2 28-56 52-86.4 69.6-10.4 5.6-20.8 11.2-32 15.2l0 411.2c40 1.6 72.8 12 109.6 24 56.8 18.4 127.2 40.8 259.2 40.8l1.6 0c66.4 0 115.2-15.2 141.6-43.2 24.8-26.4 24-56.8 24-59.2-1.6-12 4.8-23.2 15.2-29.6 20.8-12 32.8-27.2 36.8-43.2 6.4-25.6-8.8-51.2-9.6-52.8-9.6-14.4-5.6-32.8 8.8-43.2 21.6-14.4 33.6-29.6 36-46.4 4-22.4-11.2-42.4-12-44C889.6 576 889.6 561.6 896.8 550.4zM97.6 492l0 384c0 4.8-4.8 21.6 0 21.6L200 897.6 200 486.4l-94.4-2.4C100.8 484 97.6 487.2 97.6 492z" p-id="1820"></path></svg>
						 {{item.zan>0?item.zan:''}}
				
					</span>
				</div>
			</div>

			<div class="commentitem" style="text-align: center;" v-if="CommentsList.length==0" @click="ShowPLBar">
				还没有评论，抢个沙发
			</div>
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				Article: {
					cdate: "",
					contentinfo: "",
					id: "",
					image: "",
					link: "",
					product: "",
					sharecount: "",
					smlimage: "",
					status: "",
					subtype: "",
					summary: "",
					title: "",
					type: "",
					typename: "",
					viewcount: "",
					zan: "0"
				},
				id: 0,
				shareuid: "",
				qrcodeurl: "",
				zaned: false,
				mywords: "",
				CommentsList: []
			}
		},

		beforeMount() {
			let mid = this.$route.params.id
			console.log(mid)
			if(mid.indexOf('_') > 0) {
				this.id = mid.split('_')[0];
				this.shareuid = mid.split('_')[1];
			} else {
				this.id = mid
			}
			if(this.id) {
				this.GetArticle();
			}

		},
		filters: {
			decode(val) {
				try{
					return decodeURIComponent(val)
				}catch(e){
					return (val)
				}
				
			},
			gdate(val) {
				return val.split(' ')[0].replace(/\//g, '-')
			}
		},
		components: {

		},

		mounted() {
			if(this.shareuid) {
				
				this.$store.dispatch("GET", {
					url: "/api/wx/?action=getuserqrcode&uid=" + this.shareuid
				}).then(result => {
					let qrcodeurl = result.data.data
					console.log(qrcodeurl)
					if(!window.QRCode) {
						loadScript("//shanghaibus.oss-cn-shanghai.aliyuncs.com/js/qrcode.js", () => {

							var qrcode = new QRCode(document.getElementById("qrcode"), {
								width: ($(window).width() - 24) * 0.42, //设置宽高
								height: ($(window).width() - 24) * 0.42
							});
							if(this.qrcodeurl == "") {
								console.log("create qrdoe1")
								this.qrcodeurl = qrcodeurl
								qrcode.makeCode(qrcodeurl);
							}

						})
					} else {
						var qrcode = new QRCode(document.getElementById("qrcode"), {
							width: ($(window).width() - 24) * 0.42, //设置宽高
							height: ($(window).width() - 24) * 0.42
						});
						if(this.qrcodeurl == "") {
							console.log("create qrdoe2")
							this.qrcodeurl = qrcodeurl
							qrcode.makeCode(qrcodeurl);
						}
					}
				})

			}
		},
		methods: {
			GetArticle() {

				this.$store.dispatch("GET", {
					url: "/api/article/?action=one&id=" + this.id

				}).then(result => {
					if(result.data) {

						this.Article = result.data.rows[0]
						this.Article.contentinfo = decodeURIComponent(this.Article.contentinfo)
						this.$nextTick(function() {

							var maxwidth = $(window).width() - 24
							$("img", $(".content")).each(function(idx, ele) {
								var img = new Image();

								img.onload = function() {
									if(img.width > maxwidth) {
										$(ele).css("width", "100%").css("height", "auto")
									}
								}
								img.src = $(ele).attr("src")
							})

							$("video", $(".content")).css("width", "100%").css("height", "auto").attr("width", "100%").attr("height", "auto")

						})

						this.GetMyZan();
						this.GetComment();
						this.$store.dispatch("DECODEINFO", {}).then(data => {

							//分享
							this.$store.dispatch("SHARE", {
								query: {
									shareurl: window.location.href.split('#')[0]
								},
								opt: {
									title:(this.Article.title),
									desc: (this.Article.title),
									link: window.location.href.split("#")[0] + "#/article/" + this.Article.id + "_" + data.uid,
									imgUrl: this.Article.image,
									success: function() {}
								}
							}).then(result => {})

						})
					}
				})
			},
			GetMyZan() {
				this.$store.dispatch("GET", {
					url: "/api/article/?action=myzan&id=" + this.id

				}).then(result => {
					if(result.data.rows.length > 0) {
						this.zaned = true
					}
				})
			},
			ZanArt() {
				this.zaned = true;
				this.Article.zan = parseInt(this.Article.zan) + 1;
				this.$store.dispatch("GET", {
					url: "/api/article/?action=zanarticle&id=" + this.id

				}).then(result => {

				})
			},
			GetComment() {
				this.$store.dispatch("GET", {
					url: "/api/article/?action=comments&id=" + this.id

				}).then(result => {
					this.CommentsList = result.data.rows.rows
					for(let item of this.CommentsList) {

						if(item.zan == "") {
							item.zan = 0;
						} else {
							item.zan = parseInt(item.zan)
						}
						if(item.zaned == "") {
							item.zaned = false;
						} else {
							item.zaned = true
						}
					}
				})

			},
			SaveComment() {
				this.$store.dispatch("POST", {
					url: "/api/article/?action=savecomment&id=" + this.id,
					query: {
						id: this.id,
						words: this.mywords
					}

				}).then(result => {
					this.mywords = ""
					$Toast("发表成功")
					this.GetComment();
				})

			},
			ZanComment(commentid) {
				let zaned = false;
				for(let item of this.CommentsList) {
					if(item.commentid == commentid) {

						if(item.zaned) {
							zaned = true;
						} else {
							item.zaned = true;
							item.zan++;
						}
						break;
					}
				}
				if(!zaned) {
					this.$store.dispatch("GET", {
						url: "/api/article/?action=savecommentzan&articleid=" + this.id + "&commentid=" + commentid

					}).then(result => {

					})
				}

			},
			ShowPLBar() {
				$(".reply-box").show()
				$("#dmtxt").focus()
			},
			MoveTxtUp() {
				$(".reply-box").show()
				if(window._browser.versions.iPhone || window._browser.versions.iPad) {
					$("#reply-box").animate({
						translate3d: "0,-70px,0"
					}, 300, "ease-out", () => {
						//$("#dmpage").scrollTop(0)
					});
				} else {

				}

			},
			MoveTxtDown() {
				$("#reply-box").animate({
					translate3d: "0,0px,0"
				}, 300, "ease-out", function() {
					$(".reply-box").hide()
				});

			},
			GoLink() {
				if(this.Article.product != "" && this.Article.product != "0") {
					this.$router.push("/prodetail/" + this.Article.product)
				} else {
					if(this.Article.link.indexOf("http") >= 0) {
						window.location.href = this.Article.link
					}
				}
			}
		}
	}
</script>

<style @scoped>
	.title {
		font-size: 18px;
		color: #000;
	}
	
	.date {
		font-size: 12px;
		padding: 8px 0;
	}
	
	.content {
		font-size: 14px;
		text-align: justify;
	}
	
	.author {
		color: #5c91e2;
		padding: 0 10px;
	}
	
	.reply-box {
		position: fixed;
		height: 35px;
		padding-top: 5px;
		background-color: #FFFFFF;
		bottom: 0;
		left: 0;
		width: 100%;
		border-top: 1px solid #EEEEEE;
	}
	
	.reply-box>input {
		width: 79%;
		height: 29px;
		margin-left: 2%;
		padding: 0 1%;
		border: 0px solid #EEEEEE;
		box-shadow: 0 0 1px 1px #EEEEEE;
		outline: none;
		background: none;
		border-radius: 4px;
		box-sizing: border-box;
	}
	
	.btn-replay {
		display: inline-block;
		width: 14%;
		height: 30px;
		float: right;
		color: rgb(123, 121, 160);
		margin-right: 2%;
		border-radius: 4px;
		line-height: 32px;
		text-align: center;
		box-sizing: border-box;
		background: #26a1ff;
		color: #fff;
	}
	
	.commentitem {
		padding: 10px;
		background: #f6f6f6;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
		border-radius: 4px;
		margin-bottom: 6px;
	}
	
	.headimg {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		float: left;
		overflow: hidden;
	}
	
	.headimg>img {
		width: 100%;
		height: 100%;
	}
	
	.userinfo {
		margin-left: 42px;
	}
	
	.userinfo>div:nth-child(1) {
		font-size: 14px;
		color: #8c8c8c;
	}
	
	.userinfo>div:nth-child(2) {
		font-size: 12px;
		color: #afafaf;
	}
	
	.summary {
		width: 100%;
		margin: 0 auto;
		padding: 10px;
	}
	
	.commentzan {
		text-align: right;
	}
	
	.artinfo {
		padding-top: 20px;
	}
</style>